import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";

export class DemandAccountPanelCtrl implements IController {

  account: AccountModel;

  onDelete: Function;
  onClose: Function;

  private loadLimit: number;
  private shippersRef: any;
  private infiniteScroll: any;

  constructor(private $shippers, private $infiniteScroll, private $log) {
  }

  $onInit() {
    this.loadLimit = 30
    this.shippersRef = this.$shippers();
  }

  $onChanges(changes) {
    if (changes.account) {
      const currentAccount = changes.account.currentValue,
        previousAccount = changes.account.previousValue;

      if (this.account && _.get(currentAccount, 'id') !== _.get(previousAccount, 'id')) {
        if (!this.infiniteScroll) {
          this.shippersRef.$query(this._getQueryPayload());
          this.infiniteScroll = this.$infiniteScroll(this.shippersRef, this.loadLimit);
        } else {
          this._query();
        }
      }
    }
  };

  _query() {
    this.shippersRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      }, (resp) => {
        this.$log.debug('Fail to $query', resp);
      });
  }

  _getQueryPayload() {
    return {
      accountId: this.account.id,
      limit: this.loadLimit
    };
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('demandAccountPanel', {
    bindings: {
      account: '<',
      onDelete: '&',
      onClose: '&'
    },
    template: require('./demand-account-panel.html').default,
    controller: DemandAccountPanelCtrl
  });

